import PropTypes from "prop-types"
import classNames from "classnames"
import { isNil, isPlainObject } from "lodash"
import OPTooltip from "components/material/tooltip"
import { InfoOutlined } from "@mui/icons-material"
import { getMetricSignClass } from "helpers/metrics/utils"

/**
 * Component to render a summary value that may be an object (with tooltip) or a simple value.
 * Handles both new format (object with value and optional tooltip) and old format (simple value).
 */
export default function SummaryValue({ summary, formatter }) {
  // Handle new format: object with value and optional tooltip
  if (isPlainObject(summary) && "value" in summary) {
    const { value, tooltip, isPerformanceMetric } = summary
    const formattedValue = isNil(value) ? "-" : formatter(value)
    const performanceClassName = isPerformanceMetric
      ? classNames("metric-value", getMetricSignClass(value))
      : null

    if (tooltip) {
      const valueContent = performanceClassName
        ? <span className={performanceClassName}>{formattedValue}</span>
        : formattedValue
      return (
        <OPTooltip title={tooltip}>
          <span className="summary-with-tooltip">
            <InfoOutlined fontSize="small" className="summary-tooltip-icon" />
            {valueContent}
          </span>
        </OPTooltip>
      )
    }

    if (performanceClassName) {
      return <span className={performanceClassName}>{formattedValue}</span>
    }

    return <span>{formattedValue}</span>
  }

  // Handle old format: simple value (backwards compatibility)
  const formattedValue = isNil(summary) ? "-" : formatter(summary)
  return <span>{formattedValue}</span>
}

SummaryValue.propTypes = {
  summary: PropTypes.any,
  formatter: PropTypes.func.isRequired,
}
